import CircleIcon from "@mui/icons-material/Circle";
import { Box, Checkbox, Tooltip } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as ManualOfferIcon } from "../../common/icons/manualOffer.svg";
import { ShiftOrderContext } from "./newOrder/short/OrderShortDataProvider";
import { NEW_ORDER_COLUMN_WIDTHS } from "./constants";
import { hasManuallyOfferedRows } from "./newOrder/short/orderFormShortRowHandlers";
import { OrderFields } from "./orderTypes";
import { OrderFormShortRowGridItem } from "./styles";

type Props = {
  showManuallyOfferedIcon: boolean;
  showBundling: boolean;
  handleHover: (bool: boolean) => void;
  bundlingDisabled: boolean;
  hover: boolean;
  checked: boolean;
  handleBundling: () => void;
  values: OrderFields;
};

const Icons = ({
  showManuallyOfferedIcon,
  showBundling,
  bundlingDisabled,
  hover,
  checked,
  handleBundling,
  handleHover,
  values,
}: Props) => {
  const { t } = useTranslation();

  const { orderRows } = useContext(ShiftOrderContext);
  const manuallyOfferedIconSpacing = hasManuallyOfferedRows(orderRows);

  return (
    <>
      {showBundling && (
        <OrderFormShortRowGridItem
          item
          width={NEW_ORDER_COLUMN_WIDTHS.bundling}
          alignSelf="flex-start"
          onMouseOver={() => handleHover(true)}
          onMouseOut={() => handleHover(false)}
          sx={{
            paddingLeft: "2px !important",
          }}
        >
          <Tooltip
            arrow
            componentsProps={{ tooltip: { sx: { maxWidth: "460px" } } }}
            open={hover && bundlingDisabled}
            title={
              checked
                ? t("order:bundlingDisabledChecked")
                : t("order:bundlingDisabledNotChecked")
            }
          >
            <Checkbox
              disabled={bundlingDisabled}
              checked={checked}
              onClick={handleBundling}
            />
          </Tooltip>
        </OrderFormShortRowGridItem>
      )}
      <OrderFormShortRowGridItem
        item
        sx={{
          paddingLeft: "2px !important",
          height: "100%",
        }}
        width={NEW_ORDER_COLUMN_WIDTHS.fillShift}
      >
        {values.isFillShift && (
          <Box height="40px" display="flex" alignItems="center">
            <CircleIcon
              sx={{
                color: (theme) => theme.palette.warning.light,
                height: "17px",
                width: "10px",
              }}
            />
          </Box>
        )}
      </OrderFormShortRowGridItem>
      {manuallyOfferedIconSpacing && (
        <OrderFormShortRowGridItem
          item
          width={NEW_ORDER_COLUMN_WIDTHS.manualOffer}
        >
          {showManuallyOfferedIcon && (
            <Box height="40px" display="flex" alignItems="center">
              <ManualOfferIcon />
            </Box>
          )}
        </OrderFormShortRowGridItem>
      )}
    </>
  );
};

export default Icons;
